import { h, Component } from "preact";
import { Link } from 'preact-router/match';
import style from "../../../../style/admin";
import { getApiPath } from "../../../../path";
import AdminMenu from "../../../../components/admin/menu";
import AdminMenuRoman from "../../../../components/admin/menu/roman";
import SortIndicator from "../../../../components/admin/sortIndicator";

class AdminRomanListKeyword extends Component {
  state = {
    data: [],
    sorting: {
      key: "trefwoord",
      direction: "ASC"
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      data: [], // Assuming your data is fetched and stored here
      sorting: { column: null, direction: null },
      searchTerm: '', // Add state for the search term
    };
    this.CallApiForData();
  }

  CallApiForData = () => {
    let fetchPath = getApiPath(this.props.lang, `adminRoman/keywordlist`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
      .then(res => res.json())
      .then(result => {
        if (result.status == 200) {
          this.setState(previousState => ({
            ...previousState,
            data: result.data
          }));
        } else {
          console.log("Api called but not successfull", result);
        }
      });
  }

  confirmDelete(item) {
    if (this.props.lang =='nl'){
      var doDelete = `Weet u zeker dat u trefwoord '${item.trefwoord}' wilt verwijderen?`;
    }
    else{
      var doDelete = `Are you sure you want to delete keyword '${item.trefwoord}'?`;
    }
    if (confirm(doDelete)) {
      let fetchPath = getApiPath(this.props.lang, `adminRoman/keyword/${item.id}`);
      fetch(fetchPath, {
        method: 'delete',
        headers: {
          "Authorization": sessionStorage.getItem("vumc-jwt")
        }
      })
        .then(res => res.json())
        .then(result => {
          if (result.status == 200) {
            this.CallApiForData();
          }
        });
    }
  }

  onSort(sortKey) {
    const data = this.state.data;
    data.sort((b, a) => (this.state.sorting.direction == "ASC" ? a : b)[sortKey].localeCompare((this.state.sorting.direction == "ASC" ? b : a)[sortKey]))
    this.setState(previousState => ({
      ...previousState,
      data: data,
      sorting: {
        key: sortKey,
        direction: this.state.sorting.direction == "ASC" ? "DESC" : "ASC"
      }
    }));
  }
  
  handleSearchChange = (event) => {
    this.setState({ searchTerm: event.target.value });
  };

  render() {
    const { searchTerm } = this.state;

    const filteredData = this.state.data.filter(keyword => {
      return keyword.trefwoord.toLowerCase().includes(searchTerm.toLowerCase());
    });
    let list;

    //if (this.state.data.length > 0) {
    if (filteredData.length > 0) {
      //list = this.state.data.map((keyword, index) => {
      list = filteredData.map((keyword, index) => {
        return (
          <tr key={index}>
            <td>{keyword.trefwoord}</td>
            <td>{keyword.bookCount}</td>
            <td>{keyword.quoteCount}</td>
            <td>
              <Link href={"/"+ this.props.lang +"/admin/roman/keyword/" + keyword.id} class="icon edit" title={ this.props.lang == 'nl' ? 'Bewerken' : 'Edit'}></Link>
              <Link onClick={() => this.confirmDelete(keyword)} class="icon remove" title={ this.props.lang == 'nl' ? 'Verwijderen' : 'Delete'}></Link>
            </td>
          </tr>
        );
      });
    } else {
      list = <tr><td colspan="4">Loading keywords...</td></tr>;
    }

    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuRoman locale={this.props.lang} />
        <div>
          <h2> { this.props.lang == 'nl' ? 'Trefwoorden' : 'Keywords'}</h2>
          <h3>{ this.props.lang == 'nl' ?'Teller':'Counter'}:{this.state.data.length}</h3>
          <article>
            <Link href={"/"+ this.props.lang +"/admin/roman/keyword/0"}>{ this.props.lang == 'nl' ? 'Nieuwe toevoegen' : 'Add new'}</Link>
            <input
              type="text"
              placeholder={this.props.lang == 'nl' ? 'Zoeken op trefwoord...' : 'Search by keyword...'}
              value={searchTerm}
              onChange={this.handleSearchChange}
              style={{ marginBottom: '10px', display: 'block' }} // Basic styling
            />
            
            <table class="admin-table">
              <thead>
                <tr>
                  <th onClick={() => this.onSort('trefwoord')}>{ this.props.lang == 'nl' ? 'Trefwoord' : 'Keyword'} <SortIndicator column="trefwoord" settings={this.state.sorting} /></th>
                  <th width="15%" onClick={() => this.onSort('bookCount')}>{ this.props.lang == 'nl' ?'Boeken':'Books'}  <SortIndicator column="bookCount" settings={this.state.sorting} /></th>
                  <th width="15%" onClick={() => this.onSort('quoteCount')}>{ this.props.lang == 'nl' ?'Citaten':'Quotes'}  <SortIndicator column="quoteCount" settings={this.state.sorting} /></th>
                  <th width="10%">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {list}
              </tbody>
            </table>
          </article>
        </div>
      </div>
    );
  }
}

export default AdminRomanListKeyword;
